/**
 * Created by roman.kupin on 2/20/2018.
 */

import * as AudiencesApi from "../../../actions/api/audiencesApi";
import * as PropertyApi from "../../../actions/propertyApi";

export const PREFIX = "[Stories]";

export const INITIALIZED = `${PREFIX}.Initialized`;
export const TOGGLE_NEW_LIBRARY = `${PREFIX}.ToggleNewLibrary`;
export const STORIES_DATA_FETCH = `${PREFIX}.StoriesDataFetch`;
export const STORIES_DATA_FETCH_SUCCESS = `${STORIES_DATA_FETCH}.Success`;
export const STORIES_DATA_FETCH_ERROR = `${STORIES_DATA_FETCH}.Error`;

export function initialized(value) {
    return dispatch => {
        return dispatch({ type: INITIALIZED, payload: value });
    }
}

export function toggleNewLibrary(value) {
    return dispatch => {
        return dispatch({ type: TOGGLE_NEW_LIBRARY, payload: value });
    }
}

export function fetchStoriesData(propertyUuid, startDate, endDate) {
    return (dispatch, getState, { dateSerializer, Guests }) => {
        dispatch({ type: STORIES_DATA_FETCH });
        dispatch(initialized(false));
        return Promise.all([
            dispatch(AudiencesApi.getMostPopularStories(propertyUuid, dateSerializer(startDate), dateSerializer(endDate))),
            dispatch(AudiencesApi.getBroadcastWorthyStories(propertyUuid, dateSerializer(startDate), dateSerializer(endDate))),
            dispatch(AudiencesApi.getBroadcastWorthyQuotes(propertyUuid, true, dateSerializer(startDate), dateSerializer(endDate))),
            Guests.getCommonKeywords(propertyUuid),
            dispatch(PropertyApi.fetchRecommendations(propertyUuid))
        ])
            .then((datas) => {
                dispatch({ type: STORIES_DATA_FETCH_SUCCESS, payload: datas });
                dispatch(initialized(true));
                return datas;
            }, (error) => {
                dispatch({ type: STORIES_DATA_FETCH_ERROR, payload: error });
                throw error;
            });
    }

}

const All = { initialized, toggleNewLibrary, fetchStoriesData };
export default All;
